var likeShare;

likeShare = function() {
  var $, module, moduleName, socialLikes;
  $ = require('jquery');
  moduleName = 'like-share';
  module = $("." + moduleName);
  socialLikes = require('social-likes-next');
  if (module.length < 1) {
    return false;
  }
};

module.exports = likeShare;
